import React, { Suspense, useEffect, useContext } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import routes from "./../../config/app-route.jsx";
import { AppSettings } from "./../../config/app-settings.js";
import UnauthorizeRoute from "../../config/Unauthorize-app-route.jsx";
import SubExpirePanel from "../../config/SubExpireRoute..jsx";
import Preloader from "../custom/preLoader";
import {
  isAuthenticated,
  checkTokenValidity,
  isCompanyManagedSamplingOnlyUser,
} from "./axiosConfig.js";
import { isSamplingOnlyAllowedPath } from "../sidebar/menu.jsx";

function setTitle(path, routeArray) {
  var appTitle;
  for (var i = 0; i < routeArray.length; i++) {
    if (routeArray[i].path === path) {
      appTitle = "Pond Stat | " + routeArray[i].title;
    }
  }
  document.title = appTitle ? appTitle : "Pond Stat  ";
}

const Content = ({ history }) => {
  const appSettings = useContext(AppSettings);

  useEffect(() => {
    setTitle(history.location.pathname, routes);

    const unListen = history.listen(() => {
      setTitle(history.location.pathname, routes);
    });

    return () => {
      unListen();
    };
  }, [history]);

  useEffect(() => {
    if (isAuthenticated()) {
      checkTokenValidity();
    }
  }, [history.location.pathname]);

  useEffect(() => {
    if (!isAuthenticated()) return undefined;

    const onActivity = () => {
      checkTokenValidity();
    };

    const activityEvents = ["mousedown", "keydown", "scroll", "touchstart"];
    activityEvents.forEach((eventName) => {
      window.addEventListener(eventName, onActivity, { passive: true });
    });

    const intervalId = window.setInterval(onActivity, 5 * 60 * 1000);

    return () => {
      activityEvents.forEach((eventName) => {
        window.removeEventListener(eventName, onActivity);
      });
      window.clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (!isAuthenticated()) return;
    // Only company-managed owners who self-login are route-restricted.
    // Company/Super keep full navigation (scoped account only filters data).
    if (!isCompanyManagedSamplingOnlyUser()) return;
    const path = history.location.pathname;
    if (!isSamplingOnlyAllowedPath(path)) {
      history.replace("/fishingData");
    }
  }, [history, history.location.pathname]);

  const isUserAuthenticated = isAuthenticated();
  const isExpired = localStorage.getItem("isExpired");
  const isAdminHandoff = history.location.pathname === "/user/admin-handoff";

  useEffect(() => {
    if (!isUserAuthenticated || isAdminHandoff) {
      appSettings.handleSetAppSidebarNone(true);
      appSettings.handleSetAppHeaderNone(true);
      appSettings.handleSetAppContentClass("p-0");
      return;
    }
    const expired = isExpired === "true";
    appSettings.handleSetAppSidebarNone(expired);
    appSettings.handleSetAppHeaderNone(expired);
    if (!expired) {
      appSettings.handleSetAppContentClass("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthenticated, isExpired, isAdminHandoff, history.location.pathname]);

  const routeList = isAdminHandoff
    ? UnauthorizeRoute
    : isExpired === "true" && isUserAuthenticated
      ? SubExpirePanel
      : isUserAuthenticated
        ? routes
        : UnauthorizeRoute;

  return (
    <div className={"app-content " + appSettings.appContentClass}>
      <Suspense fallback={<Preloader />}>
        <Switch>
          {routeList.map((route, index) => (
            <Route
              key={`${route.path}-${index}`}
              path={route.path}
              exact={route.exact}
              component={route.component}
            />
          ))}
        </Switch>
      </Suspense>
    </div>
  );
};

export default withRouter(Content);
